import React from 'react'
import {Lang} from 'yougile-lang'
import {Hub, TimerStickerValue} from 'yougile-model'
import {Sticker} from '@components/common/base/sticker'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {getColumnInterval} from '@components/sticker/my-stickers/board-stickers/sticker-settings/stopwatch/stopwatch-column-utils'
import {TimeValue} from '@components/time-value'
import {Task} from '@extensions/task'

interface StickerProps {
  task: Hub
  timerValue: TimerStickerValue
  onShow: (e: React.MouseEvent<HTMLDivElement>) => void
  isTaskColored?: boolean
}

export const TaskTimelineSticker = (props: StickerProps) => {
  const {task, onShow, timerValue, isTaskColored} = props

  const getTime = () => {
    return getColumnInterval(task.location, task, timerValue)
  }

  return (
    <Tooltip content={Lang.msg.board.timeInColumn} placement="bottom">
      <Sticker
        icon="IconCustomTimeInColumn"
        color={isTaskColored ? 'sticker-transparent' : 'sticker-gray'}
        className={
          isTaskColored
            ? `outline-1 ${
                Task.isDone(task)
                  ? 'opacity-[.38] hover:opacity-[.64]'
                  : 'opacity-[.64] hover:opacity-100'
              }`
            : undefined
        }
        iconColor={
          isTaskColored ? 'icon-sticker-transparent' : 'icon-sticker-gray'
        }
        iconBackgroundColor={
          isTaskColored ? 'icon-sticker-transparent' : 'icon-sticker-gray'
        }
        title={<TimeValue value={getTime} fixedLength={7} />}
        onClick={onShow}
      />
    </Tooltip>
  )
}
